import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { captureRef, shouldLogVisitToday } from '../utils/referral';
import trackEvent from '../utils/trackEvent';

// Entry point for referral links: /r/:code → log a visit (once/day per code),
// store first-touch attribution + a one-time ref_click, then send the visitor
// to the landing page. ref_visit carries the CLICKED link's code (so a partner
// sees their own traffic), while ref_click uses the first-touch code.
const RefRedirect = () => {
    const { code } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (code && shouldLogVisitToday(code)) {
            trackEvent('ref_visit', { refCode: code });
        }
        const newlySet = captureRef(code);
        if (newlySet) trackEvent('ref_click', { refCode: newlySet });
        navigate('/', { replace: true });
    }, [code, navigate]);

    return null;
};

export default RefRedirect;
